import { useEffect, useState } from "react"
import { Spinner } from "react-bootstrap"
import { RouteComponentProps, useHistory } from "react-router-dom"
import { Logo } from "../../../components/Logo/Logo"
import { NavText } from "../../../components/NavElements"
import queryString from 'query-string'
import classes from './EmailActivation.module.css'
import { serverConn } from "../../../API/apiRequest"
const EmailActivation: React.FC<RouteComponentProps<{id: string, type: string}>> = (props)=>{

    const [loading, setLoading] = useState<boolean>(true)
    const [err, setErr] = useState<boolean>(false)
    const [done, setDone] = useState<boolean>(false)
    const history = useHistory()

    useEffect(()=>{
       let query = queryString.parse(props.location.search)
       const { type, id } = props.match.params
       if(!id || !type) return history.replace('/')
       if(!query.code) return history.replace('/')
       if(type.toLowerCase() !== 'er' && type.toLowerCase() !== 'ee') return history.replace('/')

       async function doVerify(){
            try{
                let id = props.match.params.id
                let code = query.code
                await serverConn.get(`/mail/active/${type}/${id}?code=${code}`)
                setLoading(false)
                setDone(true)
            }catch(e){
                console.log(e)
                setLoading(false)
                setErr(true)
            }
       }
       doVerify()
    },[history, props.location.search, props.match.params])
  
    if(loading) return <LoadingPage />
    else
    return(
      <div className={classes.container} style={{boxSizing: 'border-box', width: '100%'}}>
        <div className={classes.logoContainer}>
        <NavText to='/'><Logo /></NavText>
        </div>
        <div className={classes.spinnerContainer}>
            {done && <p style={{textAlign: 'center', color: 'rgba(0,255,0,0.8)'}}>تم تأكيد البريد الإلكتروني</p>}
            {err && <p style={{textAlign: 'center', color: 'tomato'}}>عفواً حدث خطأ اثناء التأكيد من فضلك حاول مرة اخري</p>}
            <a style={{marginTop: 25, alignSelf: 'center', color: '#fff', borderBottom: '1px solid #fff'}} href='/'>
                الرئيسية
            </a>
        </div>
      </div>
    )
  }
export const LoadingPage: React.FC = ()=>{

    return(
      <div className={classes.container} style={{boxSizing: 'border-box', width: '100%'}}>
        <div className={classes.logoContainer}>
        <NavText to='/'><Logo /></NavText>
        </div>
        <div className={classes.spinnerContainer}>
          <Spinner color='#fff' animation='border' style={{backgroundColor: '#bbb', fontSize: 60}} size={'sm'}/>
        </div>
      </div>
    )
}

export default EmailActivation